import React from 'react';
import { Form } from 'react-bootstrap';
import CheckboxRb from '../checkbox/checkbox';
import "./radioButtonRb.css";

const RadioButtonRb = (props) => {
    const containerClassName = props.className ? props.className + " leavle" : "radio-btn-containe leavle";

    if (props.checkBox) {
        return (
            <div className={containerClassName}>
                <CheckboxRb
                    label={props.label}
                    name={props.name}
                    checked={props.checked}
                    value={props.value ?? props.state}
                    onChange={props.onChange}
                    disabled={props.disabled}
                    id={props.id}
                    className="leavle"
                />
            </div>
        );
    }

    return (
        <div className={containerClassName}>
            <Form.Check
                inline
                label={props.label}
                name={props.name}
                checked={props.checked}
                type="radio"
                state={props.state}
                setstate={props.setState}
                value={props.state}
                bsPrefix="form-check"
                onSelect={props.onSelect}
                onClick={props.onClick}
                disabled={props.disabled ? true : false}
                className="leavle"
                onChange={props.onChange}
                id={props.id}
            />
        </div>
    );
};



export default RadioButtonRb;